<template>

    <main>

      <v-app-bar app :color="colorNav == '' ? 'white' : colorNav" flat dark class="app__bar">
        
          <v-list-item-title class="text-h6" >
            <a class="text-decoration-none white--text" :href="'/'">    
              {{ nomeEmpresa == '' ? "Simjob" : nomeEmpresa }}
            </a>
          </v-list-item-title>
        <v-select class="mt-4 mr-5" :items="[ ...codeCompanySite]"
          v-model="companySelected"></v-select>
        <ThemeStatusFlow />
        <MenuStatusFlow />
        <v-menu left bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on" class="tooltip">
              <v-avatar>
                <img :src="logo == '' ? require('/src/assets/logo_delta.jpg') : logo"
                  style=" height:30px; width: 30px;">
                <v-icon style="position: absolute; height: 15px; width: 15px;  font-size: 15px;  bottom: 10px;
              right: 0;"> mdi-arrow-down-drop-circle</v-icon>
              </v-avatar>
              <span class="tooltiptext">Menu</span>
            </v-btn>
          </template>

          <v-list style="cursor: pointer">
            <v-list-item>
              <v-list-item-title @click="sendLogoff()">Logoff</v-list-item-title>
            </v-list-item>
            <v-list-item>
              <v-list-item-title @click="perfilPage()">Perfil de usuário</v-list-item-title>
            </v-list-item>
            <v-list-item>
              <v-list-item-title @click="trocarPasswordPage()">Trocar de senha</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="root == true">
              <v-list-item-title @click="userPage()">Controle de acesso</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="root == true">
              <v-list-item-title @click="accountProfile()">Conta da empresa</v-list-item-title>
            </v-list-item>
            <v-list-item>
              <v-list-item-title @click="configAuthPage()">Configuração de autenticação</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="root == true">
              <v-list-item-title @click="$router.push('/customization')">Personalização</v-list-item-title>
            </v-list-item>
            <!-- <v-list-item>
              <v-list-item-title @click="$router.push('/weeklySchedule')">Programação Semanal</v-list-item-title>
            </v-list-item> -->
          </v-list>
        </v-menu>
      </v-app-bar>

      <v-navigation-drawer fixed permanent expand-on-hover class="navbar-scroll">
        <v-list nav dense>
          <!-- Logo e campo de pesquisa -->
          <v-col cols="12" align="center">
            <a class="text-decoration-none white--text" :href="'/'">
              <v-img 
                :src="logo == '' ? require('/src/assets/logo_delta.jpg') : logo"
                style="max-width:200px; max-height:200px; object-fit: contain;" 
              />
            </a>
            <!-- <v-text-field class="pt-4 pb-2" label="Pesquisar" v-model="search" /> -->
          </v-col>

      <div v-for="(modules, category, index) in groupByCategory" :key="index">
        <v-list-group>
          <template v-slot:activator>
              <v-list-item
                class="ellipsis"
                prepend-icon="mdi-folder"
                style="max-width: 180px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
              >
                <v-icon class="mr-5">
                  {{ modules[0].icon }}
                </v-icon>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span
                      v-on="on"
                      v-bind="attrs"
                      class="category-label"
                    >
                      {{ category }}
                    </span>
                  </template>
                  <span>{{ category }}</span> <!-- conteúdo do tooltip -->
                </v-tooltip>

            </v-list-item>
          </template>

        <div v-for="(module, i) in modules" :key="i">
            <v-list-item
              :title="module._type == 'action' ? module.description : module.name"
              :prepend-icon="module.icon"
              link 
              @click="module._type == 'module' ? entityNavigate(module.title) : requestRunSeparateAction(module)"
              class="ml-5"
            >
            <v-list-item-icon>
              <v-icon>{{ module.icon }}</v-icon>
            </v-list-item-icon>
              <v-list-item-title
             style="max-width: 180px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
              >{{ module._type == 'action' ? module.description : module.name }}</v-list-item-title>
            </v-list-item>
        </div>

          </v-list-group>
        </div>

        <v-list-group>
          <template v-slot:activator>
            <v-list-item prepend-icon="mdi-file-chart-outline">
              <v-list-item-title
                style="max-width: 180px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
              >
                Relatórios
              </v-list-item-title>
            </v-list-item>
          </template>

          <v-list-item class="ml-5" link @click="$router.push('/relatorios#financeiro')">
            <v-list-item-icon>
              <v-icon>mdi-cash-register</v-icon>
            </v-list-item-icon>
            <v-list-item-title style="max-width: 180px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
              Financeiro
            </v-list-item-title>
          </v-list-item>

          <v-list-item class="ml-5" link @click="$router.push('/relatorios#comercial')">
            <v-list-item-icon>
              <v-icon>mdi-briefcase-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title style="max-width: 180px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
              Comercial
            </v-list-item-title>
          </v-list-item>
        </v-list-group>

      <SobreDialog />
    </v-list>
  </v-navigation-drawer>


      <v-main class="main">
        <alertDialog/>
        <router-view></router-view>
      </v-main>

      <v-dialog v-model="actionParameterDialog" width="90vw" persistent>
        <ActionDialog v-if="actionParameterDialog" :action="requestedAction" @close="actionParameterDialog = false">
        </ActionDialog>
      </v-dialog>

    </main>

</template>

<script>
import authService from "../services/authService";
import { getSeparateActions } from "../services/actionService"
//import TimelineCard from "../components/timeline/TimelineCard";
import ActionDialog from "../components/dialogs/actionDialog.vue"
import SobreDialog from "../components/dialogs/SobreDialog.vue";
import alertDialog from "../components/dialogs/alertDialog.vue";
import MenuStatusFlow from "../components/statusFlow/menuStatusFlow.vue";
import ThemeStatusFlow from "../components/statusFlow/themeStatusFlow.vue"
import { PublicClientApplication } from '@azure/msal-browser';
import EntityService from '../services/entityService';
import Vue from "vue";



//import { notify } from "../services/nativeNotificationService";

import emitter from '@/services/emitter'
import router from "../router";

import ERP from "@apiV2/ERP.mjs";
import Schema from "@apiV2/Schema.mjs";
import useFilialStore from "@/api/v2/stores/FilialStore";
import useUsuarioStore from "@/api/v2/stores/UsuarioStore";

export default {
  name: "Home",
  data() {
    return {
      open: false,
      timelineDialog: false,
      separateActions: [],
      modules: [],
      search: "",
      actionParameterDialog: false,
      requestedAction: null,
      showDailog: false,
      root: null,
      actionsList: [],
      nomeEmpresa: '',
      colorNav: '',
      logo: '',
      entityService: new EntityService('Analysis'),
      analysis: [],
      companySite: [],
      codeCompanySite: [],
      isMultiCompany: false,
      companySelected: ''
    };
  },

  computed: {

    groupByCategory() {
      const actionsAddon = this.separateActions.filter(action =>
        this.actionsList.some(item => item.actionId === action.id)
      );

      const groupByModules = (items) => {
        return items.reduce((acc, item) => {
          const modules = item.module?.split(',');
          for (let mod of modules) {
            if (!acc[mod]) acc[mod] = [];
            const { module, ...rest } = item;
            acc[mod].push(rest);
          }
          return acc;
        }, {});
      };

      const groupByModulesActions = (items) => {
        return items.reduce((acc, item) => {
          const mod = item.module;
          if (!acc[mod]) acc[mod] = [];
          const { module, ...rest } = item;
          acc[mod].push(rest);
          return acc;
        }, {});
      };

      let itemsModule = groupByModules(this.modules);
      let itemsAddon = groupByModulesActions(actionsAddon);

      itemsModule = Object.fromEntries(
        Object.entries(itemsModule)
          .map(([category, modules]) => [
            category,
            modules.filter(m => m.permissions.includes('Menu'))
          ])
          .filter(([_, modules]) => modules.length > 0)
          .sort(([a], [b]) => a.localeCompare(b))
      );

      const allItemsMerged = { ...itemsModule };

      for (const [category, items] of Object.entries(itemsAddon)) {
        if (!allItemsMerged[category]) {
          allItemsMerged[category] = [];
        }
        allItemsMerged[category].push(...items);
      }

      const allItems = Object.fromEntries(
        Object.entries(allItemsMerged)
          .filter(([_, modules]) => modules.length > 0)
          .sort(([a], [b]) => a.localeCompare(b))
      );

      return allItems;
    },

    filteredItems() {
      var separateActions = [...this.separateActions];
      const modules = [...this.modules];

      var actionId = []
      for(var i = 0; i < this.actionsList.length; i++){
        actionId.push(this.actionsList[i].actionId)
      }
      
      separateActions = separateActions.filter(resp => actionId.indexOf(resp.id) !== -1)
      separateActions?.sort(function (a, b) {
        if (a?.description > b?.description) {
          return 1;
        }
        if (a?.description < b?.description) {
          return -1;
        }
        return 0;
      });

      modules.sort(function (a, b) {
        if (a.name > b.name) {
          return 1;
        }
        if (a.name < b.name) {
          return -1;
        }
        return 0;
      });

      let items = [...separateActions, ...modules];

      items = items.filter((item) => {
        return (
          item?.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1
        );
      });

      items = items.filter((item) => {
        if (this.selected == null) return item;
        return item.isActive === this.selected;
      });

      items.sort(function (a, b) {
        const aValue = a._type === 'action' ? a.description : a.name;
        const bValue = b._type === 'action' ? b.description : b.name;

        // console.log(aValue,bValue)

        if (aValue > bValue) {
          return 1;
        }
        if (aValue < bValue) {
          return -1;
        }
        return 0;
      });

      items = items.filter(item => item._type == 'action' || item.permissions.indexOf("Menu") >= 0)
      
      return items;
    },
  },

  components: {
    ActionDialog,
    SobreDialog,
    alertDialog,
    MenuStatusFlow,
    ThemeStatusFlow
    //TimelineCard
  },

  methods: {

    async getDashboardId(GroupUser){
      try {
      let response = await Vue.prototype.$http.get(`/Entity/Dashboard/search-fields`, { params: {value: GroupUser, searchFields: 'groupUser', page: 1, limit: 200}});
      let ids = response.data.data.data.map(item => item.id).length > 0 ? true : false;
    //   console.log(ids)
      return ids;
    } catch (err) {
      console.log("ERROR >>>>", err)
    }
    },

    async getcompanySiteIds(){


      let items = []
      let entityService = new EntityService('CompanySite')
      let dataUser = await this.$auth.getUserParams()

      if(dataUser.companySite !== null){
        items = dataUser.companySiteIds?.split(',')
      } 

      if(dataUser.companySiteIdDefault){
        items.push(dataUser.companySiteIdDefault)
      }

      if(items?.length > 0){
        let data = await entityService.getAll(1, 100, null, null, items, null)
        this.companySite = data.data.data.data
        
        this.codeCompanySite = this.companySite.map((resp) => {

          if(resp.id === dataUser?.companySiteIdDefault){
            this.companySelected = resp.codigo
          }

          return resp.codigo
        })
      }
    },
    
    async getAnalysis(){
      try{
        const req = await this.entityService.getAll(1, 30, this.search, '', '')
        return req.data.data.data;
      } catch(err){
        console.log("Error >>> ", err)
      }

    },

    perfilPage(){
      this.$router.push("/perfilUser", () => {})
    },

    accountProfile(){
      this.$router.push(`/accountProfile`, () => {})
    },

    trocarPasswordPage(){
      this.$router.push("/updatePassword", () => {})
    },

    async configAuthPage(){
      this.$router.push(`/configAuth/`, () => {});
    },

    userPage(){
      this.$router.push("/userPage", () => {})
    },

    entityNavigate(name) {
      console.log('modules >>> ', this.modules)
      this.$router.push({ name :'Entity', params: { schemaName : name}}, () => {})
      this.$forceUpdate();
    },

    analysisNavigate(item){
      this.$router.push({ name :'PivoTableView', params: { viewId: item.viewId, viewName: item.name }}, () => {});
      this.$forceUpdate();
    },

    requestRunSeparateAction (action) {
      try {
        const code = action.javascriptCode
      const fn = new Function(code);
      const result = fn();
      if(result?.type == 'addon'){
        this.$router.push(result.route)
        return
      }
      
      this.requestedAction = action
      this.actionParameterDialog = true
      }catch (err) {
        this.requestedAction = action
        this.actionParameterDialog = true
      }
      
    },

     async sendLogoff() {
        await this.$auth.removeUserParams();

        window.localStorage.removeItem("logo")
        window.localStorage.removeItem("nomeEmpresa")
        window.localStorage.removeItem("color")
        window.localStorage.removeItem("dominio")

        const homeAccountId = sessionStorage.getItem('homeAccountId');
        if(homeAccountId != null){
          this.logoofAzure(homeAccountId);
          //sessionStorage.setItem('homeAccountId', null);
          sessionStorage.clear();
        } else {
          this.$router.push("/");
        }
        
  },

  async verifyfirstAcccess(){
    const data = await this.$auth.getUserParams()
    const firstAccess = data.firstLogin
    if(firstAccess == true){
        this.$router.push("/firstAccess");
      }
  },

  logoofAzure(homeAccountId){
    const url = window.location.href.split("/#/")
    const redirectUri = url[0]

    const config = {
      auth: {
        clientId: '4c73f0aa-eecb-4474-ba92-325e59f21bf4',
        redirectUri: redirectUri,
        postLogoutRedirectUri: redirectUri
      }
    }
    
    const myMsal = new PublicClientApplication(config);

    const logoutRequest = {
      account: myMsal.getAccountByHomeId(homeAccountId),
    }

    myMsal.logoutRedirect(logoutRequest);
  }

  },

  async created(){
    //notify()
    this.nomeEmpresa = window.localStorage.getItem("nomeEmpresa");
    this.colorNav = window.localStorage.getItem("color");
    this.logo = window.localStorage.getItem("logo");

    await this.verifyfirstAcccess();
    this.analysis = await this.getAnalysis();

    await this.getcompanySiteIds()

  },


  async mounted() {

  
    const params = await authService.getUserParams();
    // console.log("Params >>>>", params)
    this.root = params.root;

    const dashboard = await this.getDashboardId(params.groupName);
    if (dashboard) {
      router.push("/dashboard")
    }

    let href = window.location.href.split('/s');

    if(href.length > 0){
      //
    }

    const userId = params.userId
    const actionsData = await this.$acessGroup.findPermissionsByUserId(userId);
    let schemas = actionsData.data?.schemas
    const actionsUser = schemas.filter(item => item.actions?.length > 0)
    actionsUser?.map((x) => {
      x.actions?.map((y) => {
        //console.log('y ', y)
        this.actionsList.push(y)
      })    
    })

    // console.log("MODULES >>> ", params.modules)

    if (params.modules) {
      this.modules = params.modules.map(mdl => {
        return {
          ...mdl,
          _type: 'module',
        }
      });
    }

    
    const separateActions = await getSeparateActions();
    if (separateActions) {
      this.separateActions = separateActions.map(action => {
        return {
          ...action,
          _type: 'action',
        }
      })
    }
    
    await emitter.on('evenWatchSchema', async (schema) => {
      if(schema.multi_company){
        this.isMultiCompany = true
      } else {
        this.isMultiCompany = false
      }
    })
  },

  watch: {
    async companySelected(value){
      if(value === 'Mostrar Todos'){
        emitter.emit('eventCompanyId', '')
      } else {

        let compayId = this.companySite.filter(resp => resp.codigo === value)[0]
        localStorage.setItem("CompanySiteIdSelected", compayId.id)
        emitter.emit('eventCompanyId', compayId.id)

        //========================================================//
        //====== PEGA E ARMAZENA FILIAL NO STORE DE FILIAL =======//
        //========================================================//
        // PEGA A FILIAL E ARMAZENA ELA NO STORE
        // PERFEITAMENTE FUNCIONA, CONTUDO, O BACKEND DO ERPG RECUSA-SE A CONSISTENTEMENTE ATRIBUIR OS DADOS PARA ELE.
        // DE VEZ EM QUANDO ELE TRÁS OS DADOS DE VEZ EM QUANDO NÃO TRÁS.

        // let filialAtualID = compayId.id;

        // let filialAtual = await ERP.getOneById(Schema.FILIAL, filialAtualID);
        // if(filialAtual.status != 200){
        //     throw filialAtual;
        // }

        // const filialStore = useFilialStore();
        // filialStore.save({
        //     id: filialAtual.data.id || "",
        //     codigo: filialAtual.data.codigo || "",
        //     descricao: filialAtual.data.descricao || "",
        //     cnpj: filialAtual.data.cnpj || "",
        //     cliente: filialAtual.data.cliente || "",
        //     fornecedor: filialAtual.data.fornecedor || "",
        //     faturamentoEntrega: filialAtual.data.faturamentoEntrega || "",
        // });

        //========================================================//
        //====== PEGA E ARMAZENA FILIAL NO STORE DE USUARIO ======//
        //========================================================//

        // const usuarioStore = useUsuarioStore();
        // usuarioStore.setFilialAtiva(compayId.id || "");

      }
    }
  }


};
</script>


<style scoped>

.category-label {
  font-size: 13px;
  font-weight: bold;
  display: inline-block;
  max-width: 130px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.app__bar{
    padding: 0 0 0 56px;
}

.main{
    margin: 64px 0 0 56px;
    padding: 24px !important;
}

.navbar-scroll .v-navigation-drawer__content {
  overflow-y: hidden;
}
.navbar-scroll:hover .v-navigation-drawer__content {
  overflow-y: scroll;
}

::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 7px;
}

::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: rgba(0,0,0,.5);
    -webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.31);
}

/* Tooltip container */
.tooltip {
  position: relative;
  display: inline-block;
  border-bottom: 1px dotted black; /* If you want dots under the hoverable text */
}

/* Tooltip text */
.tooltip .tooltiptext {
  margin-top: 5px;
  visibility: hidden;
  width: 120px;
  background-color: black;
  color: #fff;
  text-align: center;
  padding: 5px 0;
  border-radius: 6px;
 
  /* Position the tooltip text - see examples below! */
  position: absolute;
  z-index: 1;
}

/* Show the tooltip text when you mouse over the tooltip container */
.tooltip:hover .tooltiptext {
  visibility: visible;
  transition: 5s;
}

.tooltip .tooltiptext {
  top: -5px;
  right: 105%;
}
/*
.v-menu__content--fixed {
    position: fixed;
    margin-top: 45px;
}*/

</style>
